'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
import { Checklist } from '../Checklist/Checklist';
export interface SplitContentCardProps {
  attributes?: any;
  children?: ReactNode;
  photoUrl: string;
  photoHeight?: number;
  mobilePhotoHeight?: SplitContentCardProps['photoHeight'];
  titleText: string;
  checkList: Array<{
    text: string;
  }>;
}
export function SplitContentCard(props) {
  const $ = _c(32);
  const {
    isMobile,
    isTablet
  } = useBreakpoints();
  let t0;
  if ($[0] !== isMobile || $[1] !== isTablet) {
    t0 = function getProp(prop, mobileProp) {
      return isMobile || isTablet ? mobileProp || prop : prop;
    };
    $[0] = isMobile;
    $[1] = isTablet;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getProp = t0;
  const photoUrl = props.photoUrl;
  let t1;
  if ($[3] !== getProp || $[4] !== props.mobilePhotoHeight || $[5] !== props.photoHeight) {
    t1 = getProp(props.photoHeight, props.mobilePhotoHeight) ?? 300;
    $[3] = getProp;
    $[4] = props.mobilePhotoHeight;
    $[5] = props.photoHeight;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const photoHeight = t1;
  const t2 = props?.attributes?.["data-testid"];
  const t3 = props?.attributes?.["builder-id"];
  const t4 = props?.attributes?.className;
  let t5;
  if ($[7] !== t4) {
    t5 = cn("flex flex-col rounded-[33px]", t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = photoUrl ? `url('${photoUrl}?format=webp')` : undefined;
  const t7 = photoHeight ?? "auto";
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = {
      backgroundImage: t6,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: t7
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `${photoHeight}px`;
  let t10;
  if ($[12] !== t9) {
    t10 = <div style={{
      height: t9
    }} />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t8) {
    t11 = <section style={t8} className="rounded-t-[33px] bg-cover bg-center bg-no-repeat px-6 lg:h-full lg:rounded-none lg:rounded-t-[33px] lg:px-16">{t10}</section>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== props.titleText) {
    t12 = <div className="text-heading-display-2 flex size-full items-center px-6 py-4 pt-12 lg:w-2/3 lg:px-12 lg:py-4"><span>{props.titleText}</span></div>;
    $[17] = props.titleText;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== props.checkList) {
    t13 = props.checkList?.map(_temp);
    $[19] = props.checkList;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <div className="flex w-full flex-col gap-4 px-6 py-8 lg:w-1/3 lg:py-10"><Checklist iconType="outline" iconSize={30} checkIcon="CheckCircleIcon" checkColor="var(--color-bodi-accent-deep-500)" textStyle="Body XL - Medium weight" separation={20} items={t13} /></div>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t14) {
    t15 = <section className="flex flex-col items-center justify-around rounded-b-[33px] border-x border-b border-solid border-neutral-200 lg:flex-row lg:rounded-b-[33px]">{t12}{t14}</section>;
    $[23] = t12;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t11 || $[27] !== t15 || $[28] !== t2 || $[29] !== t3 || $[30] !== t5) {
    t16 = <div data-testid={t2} builder-id={t3} className={t5}>{t11}{t15}</div>;
    $[26] = t11;
    $[27] = t15;
    $[28] = t2;
    $[29] = t3;
    $[30] = t5;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}
function _temp(item) {
  return {
    value: item.text
  };
}